import { render, staticRenderFns } from "./ApprovedInvoicesIndex.vue?vue&type=template&id=4ca8a13d&scoped=true&"
import script from "./ApprovedInvoicesIndex.vue?vue&type=script&lang=js&"
export * from "./ApprovedInvoicesIndex.vue?vue&type=script&lang=js&"
import style0 from "./ApprovedInvoicesIndex.vue?vue&type=style&index=0&id=4ca8a13d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca8a13d",
  null
  
)

export default component.exports